import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ROUTES } from './menu-items';
import { RouteInfo } from './sidebar.metadata';
import { AuthService } from '../../modules/auth/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'pdhstar-card-manager-admin-sidebar',
    templateUrl: './admin-sidebar.component.html',
    styleUrls: ['./admin-sidebar.component.scss']
})
export class AdminSidebarComponent implements OnInit {
    showMenu = '';
    public sidebarnavItems: RouteInfo[] = [];

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthService,
        private toastr: ToastrService
    ) {
    }

    // this is for the open close
    addExpandClass(element: any) {
        if (element === this.showMenu) {
            this.showMenu = '0';
        } else {
            this.showMenu = element;
        }
    }

    // End open close
    ngOnInit() {
        this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
    }

    logout(): void {
        this.authService.logout().subscribe(() => {
            this.router.navigate(['login']).then(() => {
                this.toastr.success('Success logout.');
            });
        });
    }
}
